module.exports = __webpack_public_path__ + "static/media/facebook.71c3560e.svg";